import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        secondary: '#00C57E'
      }
    }
  }
})
